import React from 'react';

const Error = () => {
  return (
    <div>
      <h1>Error...</h1>
      <h2>Please refresh page</h2>
    </div>
  );
};

export default Error;
